module.exports = __webpack_public_path__ + "img/home.1a631edf.svg";